import { useQuery } from "@tanstack/react-query";
import { useCallback } from "react";
import { getStudentLearningProgresses } from "../../../api/endpoints/LearningPathEndpoints";

export default function useGetLearningPathProgresses(learningPathId: string) {
  const getLearningPathDetailsFn = useCallback(() => {
    return getStudentLearningProgresses(learningPathId);
  }, [learningPathId]);

  return useQuery({
    queryKey: ["learning-path-progresses", learningPathId],
    queryFn: getLearningPathDetailsFn,
  });
}
